module.exports = __webpack_public_path__ + "img/1440.3c3d635f.jpg";